/* eslint-disable */
import React from 'react';
import { Navigate } from 'react-router-dom';
import jwt_decode from 'jwt-decode';

// export this so other components like MPIN can use it
export const useAuth = () => {
    const token = localStorage.getItem('token') || localStorage.getItem('access_token');
    const role = localStorage.getItem('type');

    if (token) {
        try {
            const decoded = jwt_decode(token);
            const currentTime = Date.now() / 1000;

            if (decoded.exp < currentTime) {
                return 'expired'; // changed from 1
            }

            if (role === 'merchants') {
                return 'merchant'; // changed from true
            } else {
                return 'other'; // changed from 2
            }
        } catch (err) {
            console.error('Error decoding token:', err);
            return 'expired';
        }
    }

    return 'expired'; // no token treated as expired
};

const ProtectedRoute = ({ element }) => {
    const authStatus = useAuth();

    if (authStatus === 'merchant') {
        return element;
    }

    if (authStatus === 'other') {
        const role = localStorage.getItem('type');
        switch (role) {
            case 'distributor':
                return <Navigate to="/distributor/dashboard" replace />;
            case 'superdistributor':
                return <Navigate to="/super-distributor/dashboard" replace />;
            case 'relationmanager':
                return <Navigate to="/relation-manager/dashboard" replace />;
            default:
                return <Navigate to="/unauthorized" replace />;
        }
    }

    // Do not navigate on expired token, just return null
    return null;
};

export default ProtectedRoute;
